import React, { useEffect } from 'react';
import { Phone, Mail } from 'lucide-react';
import ContactForm from '../components/contactpage/ContactForm';
import ContactInfo from '../components/contactpage/ContactInfo';
import MapSection from '../components/contactpage/MapSection';


const ContactPage = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen pt-8 pb-5 md:pb-10">
      {/* Hero Section */}
      <div className="text-center mb-16 px-2 sm:px-5 md:px-12">
        <div className="max-w-4xl mx-auto">

          <p className="text-3xl sm:text-4xl md:text-5xl font-extralight text-gray-900 mb-6 tracking-tight leading-tight">
            We're Just a Call or Click Away
          </p>
          <div className="w-24 h-px bg-gradient-to-r from-transparent via-[var(--primarycolor)] to-transparent mx-auto mb-12"></div>
          
          {/* Quick contact buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <a
              href="tel:+918590442525"
              className="inline-flex items-center justify-center gap-3 bg-[var(--primarycolor)] hover:bg-red-800 text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 transform "
            >
              <Phone className="w-5 h-5" />
              Call Now
            </a>
            <a
              href="mailto:whitespacepropertiesclt@gmail.com"
              className="inline-flex items-center justify-center gap-3 bg-white border-2 border-[var(--primarycolor)] text-[var(--primarycolor)] hover:bg-[var(--primarycolor)] hover:text-white px-8 py-3 rounded-full font-semibold transition-all duration-300"
            >
              <Mail className="w-5 h-5" />
              Send Email
            </a>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-3 sm:px-6 md:px-12">
        
        {/* Contact Form and Info Section */}
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          {/* Left Column - Contact Form */}
          <div>
            <ContactForm 
            />
          </div>
          
          {/* Right Column - Contact Info */}
          <div>
            <ContactInfo 
            />
          </div>
        </div>

        {/* Map Section */}
        <div className="mb-16">
          <MapSection 
            title="Find Us Here"
            showDirectionsButton={true}
          />
        </div>
      </div>
    </div>
  );
};

export default ContactPage;